<template>
  <transition name="slide-fade">
    <default-layout>
      <v-app>
        <system-bar></system-bar>
        <v-app-bar app clipped-left elevate-on-scroll color="black" dark src="/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg" :bottom="$breakpoint.smAndDown">
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(19,84,22,.9), rgba(12,20,19,.8)"
            ></v-img>
          </template>
          <v-app-bar-nav-icon @click="drawer = !drawer" :class="drawer ? 'red--text' : ''"></v-app-bar-nav-icon>
          <v-toolbar-title role="button" href="/" @click.stop.prevent="goTo('/?redirect=' + route().current())">
            <v-img src="/maskable_icon_x512.png" width="50px" height="50px"></v-img>
          </v-toolbar-title>
          <v-toolbar-items v-if="$breakpoint.smAndUp">
            <v-btn small icon href="/" @click.stop.prevent="goTo('/?redirect=' + route().current())" fab>
              <v-icon>home</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="can['dashboard.view']">
            <v-btn :icon="$breakpoint.xsOnly" :fab="$vuetify.breakpoint.xs" class="" href="/dashboard" text @click.stop.prevent="goTo('/dashboard')">
              <span v-if="$breakpoint.xsOnly">
                <v-icon>dashboard</v-icon>
              </span>
              <span v-else>Dashboard</span>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small href="/service_requests/create" :icon="$breakpoint.xsOnly" :fab="$vuetify.breakpoint.xs" text @click.stop.prevent="goTo('/service_requests/create')">
              <v-icon left>mdi-thermometer-plus</v-icon><span v-if="!$breakpoint.xsOnly">Request</span>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items v-show="$notifications.length > 0">
            <v-btn icon @click="messagesView = true;" title="Notifications">
              <v-badge :content="$notifications.length" :value="$notifications.length" color="green" overlap>
                <v-icon>
                  mdi-bell
                </v-icon>
              </v-badge>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn @click="reloadCurrent()" text small icon fab title="Reload current page">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="$breakpoint.smAndUp">
            <v-btn @click="_changeMode()" text small icon fab title="Toggle Dark Mode">
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-show="false">
            <v-btn @click="usermenu = !usermenu" text small icon fab title="User menu">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-menu bottom left offset-y transition="fab-transition" :origin="$breakpoint.smAndDown ? 'bottom right' : 'top right'" :value="usermenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon fab v-bind="attrs" v-on="on">
                  <!-- <v-icon>mdi-dots-vertical</v-icon> -->
                  <v-avatar style="border: 1px solid;"><v-img :src="$user.profile_photo_url" lazy-src="/images/user.gif" alt="user profile photo"></v-img></v-avatar>
                </v-btn>
              </template>
              <user-menu></user-menu>
            </v-menu>
          </v-toolbar-items>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" :bottom="$breakpoint.smAndDown" :temporary="$breakpoint.smAndDown" app clipped>
          <v-list dense nav>
            <v-list-item @click.stop.prevent="goTo('/user/profile')" href="/user/profile" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" role="button">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $page.props.user.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/user/client')" href="/user/client" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="Client">
              <v-list-item-icon>
                <v-icon color="red">mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Client Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/user/requests')" href="/user/requests" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="User Service Requests">
              <v-list-item-icon>
                <v-icon color="red">mdi-message-draw</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Service Requests</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/user/professional')" href="/user/professional" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="Professional profile">
              <v-list-item-icon>
                <v-icon color="orange">mdi-account-tie</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Professional Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/invoices')" href="/invoices" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="My Invoices">
              <v-list-item-icon>
                <v-icon color="blue">mdi-cash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>My Invoices</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/tiko_requests')" href="/tiko_requests" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="TIKO Requests">
              <v-list-item-icon>
                <v-icon color="pink">mdi-gender-female</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>TIKO Requests</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/user/notifications')" href="/user/notifications" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="Notifications">
              <v-list-item-icon>
                <v-icon color="">mdi-bell</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Notifications</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop.prevent="goTo('/user/coupons')" href="/user/coupons" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="Discount Coupons">
              <v-list-item-icon>
                <v-icon color="">mdi-cash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Coupons</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-spacer v-if="$admin"></v-spacer>
            <v-list-item @click.stop.prevent="goTo('/admin')" href="/admin" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" title="Admin" v-if="$admin">
              <v-list-item-icon>
                <v-icon color="red">security</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Admin</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <template v-slot:append>
            <div class="pa-1 pull-right hidden-xs">
              <v-btn text @click="logout" small class="pull-right" outlined color="error">
                Logout
              </v-btn>
            </div>
          </template>
        </v-navigation-drawer>
        <v-navigation-drawer v-model="messagesView" app clipped right temporary :width="$notificationWidth">
          <user-notifications :notifications="$notifications"></user-notifications>
        </v-navigation-drawer>
        <v-main id="maincontent">
          <message-bar></message-bar>
          <v-snackbar :timeout="10000" v-model="snackbar" color="primary" absolute left rounded="" top multi-line>
            <span v-html="message"></span>
            <template v-slot:action="{ attrs }">
              <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
          <transition name="slide-fade" mode="out-in">
            <slot></slot>
          </transition>
          <v-snackbar :value="notifications" multi-line vertical :timeout="-1" color="deep-purple darken-4" bottom right elevation="24">
            <p>Would you like to receive notifications</p>
            <template v-slot:action="{ attrs }">
              <v-btn color="green" outlined v-bind="attrs" @click="turnonnotif" class="ring-bell" active>
                <v-icon left>mdi-bell-ring</v-icon>
                Turn On
              </v-btn>
              <v-btn color="red" text v-bind="attrs" @click="notifications = false" class="ml-5">
                Decline
              </v-btn>
            </template>
          </v-snackbar>
        </v-main>
      </v-app>
    </default-layout>
  </transition>
</template>

<script>
  import UserMenu from '@/Components/components/user-menu'
  import DefaultLayout from '@/Layouts/Default'
  import SystemBar from '@/Layouts/systembar'
  import Vue from 'vue'
  import VueCookie from 'vue-cookie'
  const MessageBar = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/messagebar')
  const UserNotifications = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/Notifications/notifications')

  Vue.use(VueCookie)

  export default {
    name: 'user-layout',
    components: {
      UserMenu,
      SystemBar,
      MessageBar,
      DefaultLayout,
      UserNotifications,
    },
    metaInfo () {
      return {
        title: 'User Dashboard'
      }
    },
    data () {
      return {
        drawer: false,
        webpushsuccess: false,
        snackbar: false,
        message: '',
        usergenerated: false,
        notifications: false,
        usermenu: false,
        messagesView: false,
      }
    },
    methods: {
      logout () {
        this.$cookie.set('loggedout', true, { expires: '1D' })
        this.$inertia.post('/logout')
      },
      getprofile () {
        this.$inertia.visit('/user/profile')
      },
      goToLink (url) {
        this.$inertia.visit(url)
      },
      reloadCurrent () {
        this.$inertia.reload({ preserveScroll: true, preserveState: false })
      },
      turnonnotif () {
        this.notifications = false
        this.usergenerated = true
        if (!('Notification' in window)) {
          this.message = 'Your browser doesn\'t support Notifications'
          this.snackbar = true
          return
        }
        if (Notification.permission === 'denied') {
          this.message = 'You have explicitly denied notifications for this app. <br>Please reset notifications settings for this url ' + window.location.origin
          this.snackbar = true
        }
        window.dispatchEvent(new CustomEvent('notifyme'));
      },
      checkNotif () {
        if ('Notification' in window) {
          if (Notification.permission != 'granted') {
            this.notifications = true
          }
        }
      },
      closedrawer () {
        if (this.$breakpoint.smAndDown) {
          this.drawer = false
        }
      }
    },
    computed: {
      professional () {
        return this.$user.professional
      },
      webpush () {
        return ('Notification' in window) && Notification.permission === 'granted'
      }
    },
    mounted () {
      var vm = this
      this.checkNotif()
      window.addEventListener('notifyon', function () {
        vm.webpushsuccess = true
      })
      this.$nextTick(() => {
        var cookie = this.$cookie.get('loggedout')
        if (cookie) {
          this.$cookie.delete('loggedout')
        }
      })
    },
    watch: {
      'webpushsuccess': function (value) {
        if (value  && this.usergenerated) {
          this.message = 'Notifications turned on successfully'
          this.snackbar = true
        }
      }
    }
  }
</script>
<style>
  .hidden {
    display: none;
  }
  [role="button"] {
    cursor: pointer;
  }
  @media screen and (min-width: 703px) {
    .v-dialog:not(.v-dialog--fullscreen) {
      max-width: 60vw;
    }
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 1px;
  }
  .v-dialog {
    margin: 5px;
  }
  .v-card__title.primary {
    color: white;
  }
  @keyframes swing {
    0% {transform: rotate(-30deg); transform-origin: 50% 0%;}
    25% {transform: rotate(30deg); transform-origin: 50% 0%;}
    50% {transform: rotate(-30deg); transform-origin: 50% 0%;}
    75% {transform: rotate(30deg); transform-origin: 50% 0%;}
    100% {transform: rotate(-30deg); transform-origin: 50% 0%;}
  }
  .ring-bell:hover > .v-btn__content  > i {
    animation-name: swing;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: alternate-reverse;
    animation-timing-function: linear;
  }
</style>
